const convertPoisFromPoiBank = pois => {
  const data = [];
  pois.forEach(element => {
    const poi = convertPoiFromPoiBank(element);
    data.push(poi);
  });
  return data;
};

const convertPoiFromPoiBank = object => {
  const poi = { ...object };
  const {
    id,
    data_source,
    original_name,
    opening_hours,
    address,
    city,
    country,
    photo,
  } = poi;
  poi._id = id.toString();
  poi.dataSource = data_source.toString();
  if (original_name) {
    poi.originalName = original_name;
    delete poi.original_name;
  }
  poi.poiBankNextId = id.toString();
  if (opening_hours) {
    poi.openingHours = opening_hours;
    delete poi.opening_hours;
  }
  if (!address || address.length === 0) {
    let newAddress = '';
    if (city) {
      newAddress += city.name;
    }
    if (country) {
      newAddress += country.name;
    }
    if (newAddress) {
      poi.address = newAddress;
    }
  }
  if (photo) {
    poi.thumbnailForPost = thumbnailImageUrlForPostByPhotoResult(photo);
  }
  delete poi.id;
  delete poi.data_source;
  return poi;
};

const thumbnailImageUrlForPostByPhotoResult = object => {
  const {
    file: fileName,
    width: originalWidth,
    height: originalHeight,
  } = object;
  const ratio = originalHeight / originalWidth;
  return `https://host/signature/ratio:${ratio}/${fileName}`;
};

export {
  convertPoisFromPoiBank,
  convertPoiFromPoiBank,
  thumbnailImageUrlForPostByPhotoResult,
};
